export const students = [
  { id: 1, name: "Student 1", image: "/images/students/1.jpg" },
  { id: 2, name: "Student 2", image: "/images/students/2.jpg" },
  { id: 3, name: "Student 3", image: "/images/students/3.jpg" },
  { id: 4, name: "Student 4", image: "/images/students/4.jpg" },
];
